module.exports = "/assets/data/0325af10bfd4dee061dde1d8197886ba-SN4.data.json";